import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_like",
  "use": "icon_like-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon_like\"><rect width=\"32\" height=\"32\" rx=\"12\" fill=\"#78C288\" /><path d=\"M22.02 15.864l-5.903 6.075c-.08.081-.148.081-.229 0l-5.904-6.075c-1.228-1.265-1.478-3.659.246-5.124 1.31-1.112 3.329-.945 4.594.357l1.179 1.214 1.178-1.214c1.272-1.309 3.292-1.469 4.594-.36 1.72 1.465 1.464 3.872.246 5.127z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol